module.exports = __webpack_public_path__ + "static/partner_cima-3d811f9712b07a8ee00ecbebaa58b715.svg";